const disciplinas =
[
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS010",
    "Período": 1,
    "Nome da disciplina": "ADMINISTRAÇÃO DE SISTEMAS",
    "Docente responsável": "Mauro Castro",
    "Contato do.pdfente": "mauro.castro@ufpr.br",
    "Número de vagas (veteranos/calouros)": "20(5/15)",
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "quarta",
    "Horário (ativ. síncronas)": "16:30-17:30",
    "CH Sem Síncrona": 1,
    "CH Sem Assíncrona": 3,
    "CH Sem": 4,
    "Semanas": 15,
    "Data de início": "03/11/2020",
    "Data de fim": "27/03/2021",
    "Período Recesso": "21/12/20 a 16/01/21; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS ou UFPR Virtual e E-mail",
    "Planos de Ensino": "ds010_t.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS010",
    "Período": 1,
    "Nome da disciplina": "ADMINISTRAÇÃO DE SISTEMAS",
    "Docente responsável": "Mauro Castro",
    "Contato do.pdfente": "mauro.castro@ufpr.br",
    "Número de vagas (veteranos/calouros)": "40(5/35)",
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "quarta",
    "Horário (ativ. síncronas)": "21:00-22:00",
    "CH Sem Síncrona": 1,
    "CH Sem Assíncrona": 3,
    "CH Sem": 4,
    "Semanas": 15,
    "Data de início": "03/11/2020",
    "Data de fim": "27/03/2021",
    "Período Recesso": "21/12/20 a 16/01/21; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS ou UFPR Virtual e E-mail",
    "Planos de Ensino": "ds010_n.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS211",
    "Período": 1,
    "Nome da disciplina": "Sistemas de Informação T",
    "Docente responsável": "Mario de Paula Soares Filho",
    "Contato do.pdfente": "paulasoares@ufpr.br",
    "Número de vagas (veteranos/calouros)": "30(5/25)",
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "segunda",
    "Horário (ativ. síncronas)": "19:00-20:00",
    "CH Sem Síncrona": 1,
    "CH Sem Assíncrona": 2,
    "CH Sem": 3,
    "Semanas": 10,
    "Data de início": "03/11/2020",
    "Data de fim": "27/03/2021",
    "Período Recesso": "21/12/20 a 16/01/21; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS, Siga e whatsapp,youtube",
    "Planos de Ensino": "ds211.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS211",
    "Período": 1,
    "Nome da disciplina": "Sistemas de Informação N",
    "Docente responsável": "Mario de Paula Soares Filho",
    "Contato do.pdfente": "paulasoares@ufpr.br",
    "Número de vagas (veteranos/calouros)": "70(5/65)",
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "segunda",
    "Horário (ativ. síncronas)": "19:00-20:00",
    "CH Sem Síncrona": 1,
    "CH Sem Assíncrona": 2,
    "CH Sem": 3,
    "Semanas": 10,
    "Data de início": "03/11/2020",
    "Data de fim": "27/03/2021",
    "Período Recesso": "21/12/20 a 16/01/21; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS, Siga e whatsapp,youtube",
    "Planos de Ensino": "ds211.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS110",
    "Período": 1,
    "Nome da disciplina": "Proj de Algoritmos e Prat de Programação",
    "Docente responsável": "Luiz Antonio Passos Cardoso",
    "Contato do.pdfente": "lcardoscx@gmail.com",
    "Número de vagas (veteranos/calouros)": "50(5/45)",
    "Carga Horária da disciplina": 90,
    "Dias da semana (ativ. síncronas)": "quinta",
    "Horário (ativ. síncronas)": "19:00-23:00",
    "CH Sem Síncrona": 4,
    "CH Sem Assíncrona": 2,
    "CH Sem": 6,
    "Semanas": 15,
    "Data de início": "03/11/2020",
    "Data de fim": "25/03/2021",
    "Período Recesso": "21/12/20 a 16/01/21; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "Teams, UFPR Virtual e email",
    "Planos de Ensino": "ds110_t.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS100",
    "Período": 1,
    "Nome da disciplina": "Proj de Algoritmos e Prat de Programação",
    "Docente responsável": "Luiz Antonio Passos Cardoso",
    "Contato do.pdfente": "lcardoscx@gmail.com",
    "Número de vagas (veteranos/calouros)": "50(5/45)",
    "Carga Horária da disciplina": 90,
    "Dias da semana (ativ. síncronas)": "quinta",
    "Horário (ativ. síncronas)": "14:30-18:30",
    "CH Sem Síncrona": 4,
    "CH Sem Assíncrona": 2,
    "CH Sem": 6,
    "Semanas": 15,
    "Data de início": "03/11/2020",
    "Data de fim": "25/03/2021",
    "Período Recesso": "21/12/20 a 16/01/21; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "Teams, UFPR Virtual e email",
    "Planos de Ensino": "ds110_n.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS011",
    "Período": 1,
    "Nome da disciplina": "Introdução Arquitetura de Computadores",
    "Docente responsável": "Pedro R. Torres Jr.",
    "Contato do.pdfente": "pedro.torres@ufpr.br",
    "Número de vagas (veteranos/calouros)": "80(5/75)",
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "terça",
    "Horário (ativ. síncronas)": "19:00-20:00",
    "CH Sem Síncrona": 1,
    "CH Sem Assíncrona": 7,
    "CH Sem": 8,
    "Semanas": 7.5,
    "Data de início": "03/11/2020",
    "Data de fim": "09/02/2021",
    "Período Recesso": "19/12/2020 a 03/02/2021",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS, SIGA e Telegram",
    "Planos de Ensino": "ds011.pdf",
    "Meses": "nov,dez,jan,fev"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS011",
    "Período": 1,
    "Nome da disciplina": "Introdução Arquitetura de Computadores",
    "Docente responsável": "Pedro R. Torres Jr.",
    "Contato do.pdfente": "pedro.torres@ufpr.br",
    "Número de vagas (veteranos/calouros)": "80(5/75)",
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "terça",
    "Horário (ativ. síncronas)": "18:00-19:00",
    "CH Sem Síncrona": 1,
    "CH Sem Assíncrona": 7,
    "CH Sem": 8,
    "Semanas": 7.5,
    "Data de início": "03/11/2020",
    "Data de fim": "09/02/2021",
    "Período Recesso": "19/12/2020 a 03/02/2021",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS, SIGA e Telegram",
    "Planos de Ensino": "ds011.pdf",
    "Meses": "nov,dez,jan,fev"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS121",
    "Período": 2,
    "Nome da disciplina": "Linguagem de Programação",
    "Docente responsável": "Dieval Guizelini",
    "Contato do.pdfente": "dieval@ufpr.br",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 75,
    "Dias da semana (ativ. síncronas)": "segunda",
    "Horário (ativ. síncronas)": "19:00-21:00",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 4,
    "CH Sem": 6,
    "Semanas": 13,
    "Data de início": "09/11/2020",
    "Data de fim": "27/03/2021",
    "Período Recesso": "21/12/20 a 16/01/21; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "Teams, moodle, farmaalg",
    "Planos de Ensino": "ds121.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS121",
    "Período": 2,
    "Nome da disciplina": "Linguagem de Programação",
    "Docente responsável": "Dieval Guizelini",
    "Contato do.pdfente": "dieval@ufpr.br",
    "Número de vagas (veteranos/calouros)": 60,
    "Carga Horária da disciplina": 75,
    "Dias da semana (ativ. síncronas)": "segunda",
    "Horário (ativ. síncronas)": "19:00-21:00",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 4,
    "CH Sem": 6,
    "Semanas": 13,
    "Data de início": "09/11/2020",
    "Data de fim": "27/03/2021",
    "Período Recesso": "21/12/20 a 16/01/21; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "Teams, moodle, farmaalg",
    "Planos de Ensino": "ds121.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS220",
    "Período": 2,
    "Nome da disciplina": "Análise e Projetos de Sistemas I T",
    "Docente responsável": "Sandramara K P Soares",
    "Contato do.pdfente": "sskusano@ufpr.br",
    "Número de vagas (veteranos/calouros)": 40,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "segunda",
    "Horário (ativ. síncronas)": "14:30-16:30",
    "CH Sem Síncrona": 4,
    "CH Sem Assíncrona": 4,
    "CH Sem": 8,
    "Semanas": 8,
    "Data de início": "04/11/2020",
    "Data de fim": "27/01/2021",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS, Siga (email) e whatsapp",
    "Planos de Ensino": "ds220_t.pdf",
    "Meses": "nov,dez,jan"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS220",
    "Período": 2,
    "Nome da disciplina": "Análise e Projetos de Sistemas I T",
    "Docente responsável": "Sandramara K P Soares",
    "Contato do.pdfente": "sskusano@ufpr.br",
    "Número de vagas (veteranos/calouros)": 40,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "quarta",
    "Horário (ativ. síncronas)": "14:30-16:30",
    "CH Sem Síncrona": 4,
    "CH Sem Assíncrona": 4,
    "CH Sem": 8,
    "Semanas": 8,
    "Data de início": "04/11/2020",
    "Data de fim": "27/01/2021",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS, Siga (email) e whatsapp",
    "Planos de Ensino": "ds220_t.pdf",
    "Meses": "nov,dez,jan"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS220",
    "Período": 2,
    "Nome da disciplina": "Análise e Projetos de Sistemas I - N",
    "Docente responsável": "Jaime Wojciechowski",
    "Contato do.pdfente": "jaimewo@ufpr.br",
    "Número de vagas (veteranos/calouros)": 60,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "terça",
    "Horário (ativ. síncronas)": "19:00-21:00",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 6,
    "CH Sem": 8,
    "Semanas": 9,
    "Data de início": "03/11/2020",
    "Data de fim": "23/01/2020",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "Teams, UFPR Virtual",
    "Planos de Ensino": "ds220_n.pdf",
    "Meses": "nov,dez,jan"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS221",
    "Período": 2,
    "Nome da disciplina": "Modelagem de negócios T",
    "Docente responsável": "Mario de Paula Soares Filho",
    "Contato do.pdfente": "paulasoares@ufpr.br",
    "Número de vagas (veteranos/calouros)": 50,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "terça",
    "Horário (ativ. síncronas)": "14:30-16:30",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 4,
    "CH Sem": 6,
    "Semanas": 10,
    "Data de início": "03/11/2020",
    "Data de fim": "27/03/2021",
    "Período Recesso": "21/12/20 a 16/01/21; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS, Siga e whatsapp,youtube",
    "Planos de Ensino": "ds221.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS221",
    "Período": 2,
    "Nome da disciplina": "Modelagem de negócios N",
    "Docente responsável": "Mario de Paula Soares Filho",
    "Contato do.pdfente": "paulasoares@ufpr.br",
    "Número de vagas (veteranos/calouros)": 50,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "quarta",
    "Horário (ativ. síncronas)": "20:00-22:00",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 4,
    "CH Sem": 6,
    "Semanas": 10,
    "Data de início": "03/11/2020",
    "Data de fim": "27/03/2021",
    "Período Recesso": "21/12/20 a 16/01/21; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS, Siga e whatsapp,youtube",
    "Planos de Ensino": "ds221.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS122",
    "Período": 2,
    "Nome da disciplina": "Desenvolvimento Web 1",
    "Docente responsável": "Alexander Kutzke",
    "Contato do.pdfente": "alexander@ufpr.br",
    "Número de vagas (veteranos/calouros)": 25,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "sexta",
    "Horário (ativ. síncronas)": "19:00-21:00",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 4.6,
    "CH Sem": 4.6,
    "Semanas": 9,
    "Data de início": "18/01/2021",
    "Data de fim": "27/03/2021",
    "Período Recesso": "carnaval",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS, Telegram, email e Gitlab; Dia de atividades síncronas pode ser outro",
    "Planos de Ensino": "ds122.pdf",
    "Meses": "jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS122",
    "Período": 2,
    "Nome da disciplina": "Desenvolvimento Web 1",
    "Docente responsável": "Alexander Kutzke",
    "Contato do.pdfente": "alexander@ufpr.br",
    "Número de vagas (veteranos/calouros)": 55,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "sexta",
    "Horário (ativ. síncronas)": "19:00-21:00",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 4.6,
    "CH Sem": 6.6,
    "Semanas": 9,
    "Data de início": "18/01/2021",
    "Data de fim": "27/03/2021",
    "Período Recesso": "carnaval",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS, Telegram, email e Gitlab; Dia de atividades síncronas pode ser outro",
    "Planos de Ensino": "ds122.pdf",
    "Meses": "jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS020",
    "Período": 2,
    "Nome da disciplina": "Redes de Computadores",
    "Docente responsável": "Pedro R. Torres Jr.",
    "Contato do.pdfente": "pedro.torres@ufpr.br",
    "Número de vagas (veteranos/calouros)": 10,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "quarta",
    "Horário (ativ. síncronas)": "19:00-20:00",
    "CH Sem Síncrona": 1,
    "CH Sem Assíncrona": 7,
    "CH Sem": 8,
    "Semanas": 7.5,
    "Data de início": "03/02/2021",
    "Data de fim": "24/03/2021",
    "Período Recesso": "19/12/2020 a 03/02/2021; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS, SIGA e Telegram",
    "Planos de Ensino": "ds020.pdf",
    "Meses": "fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48B",
    "Código da disciplina": "DS020",
    "Período": 2,
    "Nome da disciplina": "Redes de Computadores",
    "Docente responsável": "Pedro R. Torres Jr.",
    "Contato do.pdfente": "pedro.torres@ufpr.br",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "quarta",
    "Horário (ativ. síncronas)": "18:00-19:00",
    "CH Sem Síncrona": 1,
    "CH Sem Assíncrona": 7,
    "CH Sem": 8,
    "Semanas": 7.5,
    "Data de início": "03/02/2021",
    "Data de fim": "24/03/2021",
    "Período Recesso": "19/12/2020 a 03/02/2021; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS, SIGA e Telegram",
    "Planos de Ensino": "ds020.pdf",
    "Meses": "fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS230",
    "Período": 3,
    "Nome da disciplina": "Análise e Projetos de Sistemas II - N",
    "Docente responsável": "Jaime Wojciechowski",
    "Contato do.pdfente": "jaimewo@ufpr.br",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 90,
    "Dias da semana (ativ. síncronas)": "terça",
    "Horário (ativ. síncronas)": "21:00-23:00",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 10,
    "CH Sem": 12,
    "Semanas": 9,
    "Data de início": "03/11/2020",
    "Data de fim": "23/01/2020",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "Teams, UFPR Virtual",
    "Planos de Ensino": "ds230.pdf",
    "Meses": "nov,dez,jan"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS230",
    "Período": 3,
    "Nome da disciplina": "Análise e Projetos de Sistemas II - N",
    "Docente responsável": "Jaime Wojciechowski",
    "Contato do.pdfente": "jaimewo@ufpr.br",
    "Número de vagas (veteranos/calouros)": 50,
    "Carga Horária da disciplina": 90,
    "Dias da semana (ativ. síncronas)": "terça",
    "Horário (ativ. síncronas)": "21:00-23:00",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 10,
    "CH Sem": 12,
    "Semanas": 9,
    "Data de início": "03/11/2020",
    "Data de fim": "23/01/2020",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "Teams, UFPR Virtual",
    "Planos de Ensino": "ds230.pdf",
    "Meses": "nov,dez,jan"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS130",
    "Período": 3,
    "Nome da disciplina": "Estruturas de Dados I",
    "Docente responsável": "Andreia de Jesus",
    "Contato do.pdfente": "andreia.jesus@ufpr.br",
    "Número de vagas (veteranos/calouros)": 20,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 4,
    "CH Sem": 4,
    "Semanas": 15,
    "Data de início": "03/11/2020",
    "Data de fim": "27/03/2021",
    "Período Recesso": "19/12/2020 a 01/02/2021; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS e email; As atividades síncronas são para dúvidas (se necessário) e apresentação de trabalhos. Serão marcadas diretamente com a turma. ",
    "Planos de Ensino": "ds130.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS130",
    "Período": 3,
    "Nome da disciplina": "Estruturas de Dados I",
    "Docente responsável": "Andreia de Jesus",
    "Contato do.pdfente": "andreia.jesus@ufpr.br",
    "Número de vagas (veteranos/calouros)": 40,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 4,
    "CH Sem": 4,
    "Semanas": 15,
    "Data de início": "03/11/2020",
    "Data de fim": "27/03/2021",
    "Período Recesso": "19/12/2020 a 01/02/2022; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS e email; As atividades síncronas são para dúvidas (se necessário) e apresentação de trabalhos. Serão marcadas diretamente com a turma. ",
    "Planos de Ensino": "ds130.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS622",
    "Período": 3,
    "Nome da disciplina": "Comportamento Organizacional",
    "Docente responsável": "Maria Valéria da Costa",
    "Contato do.pdfente": "valerialua27@gmail.com",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 45,
    "Dias da semana (ativ. síncronas)": "quarta",
    "Horário (ativ. síncronas)": "14:30-16:30",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 3,
    "CH Sem": 5,
    "Semanas": 9,
    "Data de início": "03/11/2020",
    "Data de fim": "03/03/2021",
    "Período Recesso": "21/12/2020 a 31/01/2021; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS ou UFPR Virtual e E-mail SIGA",
    "Planos de Ensino": "ds622_t.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS622",
    "Período": 3,
    "Nome da disciplina": "Comportamento Organizacional",
    "Docente responsável": "Maria Valéria da Costa",
    "Contato do.pdfente": "valerialua27@gmail.com",
    "Número de vagas (veteranos/calouros)": 60,
    "Carga Horária da disciplina": 45,
    "Dias da semana (ativ. síncronas)": "quarta",
    "Horário (ativ. síncronas)": "19:00-21:00",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 3,
    "CH Sem": 5,
    "Semanas": 9,
    "Data de início": "03/11/2020",
    "Data de fim": "03/03/2021",
    "Período Recesso": "21/12/2020 a 31/01/2021; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS ou UFPR Virtual e E-mail SIGA",
    "Planos de Ensino": "ds622_n.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS131",
    "Período": 3,
    "Nome da disciplina": "Linguagem de Programação Orientada a Objetos I",
    "Docente responsável": "Rafael Romualdo Wandresen",
    "Contato do.pdfente": "rafaelwand@gmail.com",
    "Número de vagas (veteranos/calouros)": 20,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "quinta",
    "Horário (ativ. síncronas)": "19:00-22:00",
    "CH Sem Síncrona": 3,
    "CH Sem Assíncrona": 2,
    "CH Sem": 5,
    "Semanas": 12,
    "Data de início": "03/11/2020",
    "Data de fim": "27/03/2021",
    "Período Recesso": "21/12/20 a 16/01/21; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS",
    "Planos de Ensino": "ds131.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS131",
    "Período": 3,
    "Nome da disciplina": "Linguagem de Programação Orientada a Objetos I",
    "Docente responsável": "Rafael Romualdo Wandresen",
    "Contato do.pdfente": "rafaelwand@gmail.com",
    "Número de vagas (veteranos/calouros)": 40,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "quinta",
    "Horário (ativ. síncronas)": "19:00-22:00",
    "CH Sem Síncrona": 3,
    "CH Sem Assíncrona": 2,
    "CH Sem": 5,
    "Semanas": 12,
    "Data de início": "03/11/2020",
    "Data de fim": "27/03/2021",
    "Período Recesso": "21/12/20 a 16/01/21; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS",
    "Planos de Ensino": "ds131.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS030",
    "Período": 3,
    "Nome da disciplina": "Sistemas Operacionais",
    "Docente responsável": "Alessandro Brawerman",
    "Contato do.pdfente": "brawerman@ufpr.br",
    "Número de vagas (veteranos/calouros)": 10,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "terça",
    "Horário (ativ. síncronas)": "14:30-16:30",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 3,
    "CH Sem": 5,
    "Semanas": 12,
    "Data de início": "10/11/2020",
    "Data de fim": "16/03/2021",
    "Período Recesso": "19/12/2020 a 01/02/2021; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "Teams e e-mail",
    "Planos de Ensino": "ds030.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS030",
    "Período": 3,
    "Nome da disciplina": "Sistemas Operacionais",
    "Docente responsável": "Alessandro Brawerman",
    "Contato do.pdfente": "brawerman@ufpr.br",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "terça",
    "Horário (ativ. síncronas)": "14:30-16:30",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 3,
    "CH Sem": 5,
    "Semanas": 12,
    "Data de início": "10/11/2020",
    "Data de fim": "16/03/2021",
    "Período Recesso": "19/12/2020 a 01/02/2021; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "Teams e e-mail",
    "Planos de Ensino": "ds030.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS630",
    "Período": 3,
    "Nome da disciplina": "Direito Aplicado",
    "Docente responsável": "Silvana Maria Carbonera",
    "Contato do.pdfente": "silvana.carbonera@ufpr.br",
    "Número de vagas (veteranos/calouros)": 10,
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "terça",
    "Horário (ativ. síncronas)": "19:00-21:00",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 3,
    "CH Sem": 5,
    "Semanas": 6,
    "Data de início": "03/11/2020",
    "Data de fim": "11/12/2020",
    "Período Recesso": "não se aplica",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS e SIGA (email)",
    "Planos de Ensino": "ds630.pdf",
    "Meses": "nov,dez"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS630",
    "Período": 3,
    "Nome da disciplina": "Direito Aplicado",
    "Docente responsável": "Silvana Maria Carbonera",
    "Contato do.pdfente": "silvana.carbonera@ufpr.br",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "terça",
    "Horário (ativ. síncronas)": "19:00-21:00",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 3,
    "CH Sem": 5,
    "Semanas": 6,
    "Data de início": "03/11/2020",
    "Data de fim": "11/12/2020",
    "Período Recesso": "não se aplica",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS e SIGA (email)",
    "Planos de Ensino": "ds630.pdf",
    "Meses": "nov,dez"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS340",
    "Período": 4,
    "Nome da disciplina": "BANCO DE DADOS III",
    "Docente responsável": "João Eugenio Marynowski",
    "Contato do.pdfente": "jeugenio@ufpr.br",
    "Número de vagas (veteranos/calouros)": 40,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "quarta",
    "Horário (ativ. síncronas)": "14:30-16:30",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 6,
    "CH Sem": 8,
    "Semanas": "7,5",
    "Data de início": "27/01/2020",
    "Data de fim": "25/03/2020",
    "Período Recesso": "21/12/20 a 16/01/21; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS ou UFPR Virtual e E-mail",
    "Planos de Ensino": "ds340.pdf",
    "Meses": "jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS340",
    "Período": 4,
    "Nome da disciplina": "BANCO DE DADOS III",
    "Docente responsável": "João Eugenio Marynowski",
    "Contato do.pdfente": "jeugenio@ufpr.br",
    "Número de vagas (veteranos/calouros)": 40,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "quarta",
    "Horário (ativ. síncronas)": "21:00-23:00",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 6,
    "CH Sem": 8,
    "Semanas": "7,5",
    "Data de início": "27/01/2020",
    "Data de fim": "25/03/2020",
    "Período Recesso": "21/12/20 a 16/01/21; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS ou UFPR Virtual e E-mail",
    "Planos de Ensino": "ds340.pdf",
    "Meses": "jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS240",
    "Período": 4,
    "Nome da disciplina": "Engenharia de Software I",
    "Docente responsável": "Rafaela Mantovani Fontana",
    "Contato do.pdfente": "rafaela.fontana@ufpr.br",
    "Número de vagas (veteranos/calouros)": 40,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "terça",
    "Horário (ativ. síncronas)": "16:30-18:30",
    "CH Sem Síncrona": 4,
    "CH Sem Assíncrona": 6,
    "CH Sem": 10,
    "Semanas": 6,
    "Data de início": "03/11/2020",
    "Data de fim": "11/12/2020",
    "Período Recesso": "não se aplica",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS",
    "Planos de Ensino": "ds240.pdf",
    "Meses": "nov,dez"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS240",
    "Período": 4,
    "Nome da disciplina": "Engenharia de Software I",
    "Docente responsável": "Rafaela Mantovani Fontana",
    "Contato do.pdfente": "rafaela.fontana@ufpr.br",
    "Número de vagas (veteranos/calouros)": 40,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "quinta",
    "Horário (ativ. síncronas)": "16:30-18:30",
    "CH Sem Síncrona": 4,
    "CH Sem Assíncrona": 6,
    "CH Sem": 10,
    "Semanas": 6,
    "Data de início": "03/11/2020",
    "Data de fim": "11/12/2020",
    "Período Recesso": "não se aplica",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS",
    "Planos de Ensino": "ds240.pdf",
    "Meses": "nov,dez"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS240",
    "Período": 4,
    "Nome da disciplina": "Engenharia de Software I",
    "Docente responsável": "Rafaela Mantovani Fontana",
    "Contato do.pdfente": "rafaela.fontana@ufpr.br",
    "Número de vagas (veteranos/calouros)": 40,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "segunda",
    "Horário (ativ. síncronas)": "19:00-21:00",
    "CH Sem Síncrona": 4,
    "CH Sem Assíncrona": 6,
    "CH Sem": 10,
    "Semanas": 6,
    "Data de início": "03/11/2020",
    "Data de fim": "11/12/2020",
    "Período Recesso": "não se aplica",
    "Meios de comunicação utilizados?": "Teams, M.pdfe TADS",
    "Planos de Ensino": "ds240.pdf",
    "Meses": "nov,dez"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS240",
    "Período": 4,
    "Nome da disciplina": "Engenharia de Software I",
    "Docente responsável": "Rafaela Mantovani Fontana",
    "Contato do.pdfente": "rafaela.fontana@ufpr.br",
    "Número de vagas (veteranos/calouros)": 40,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "quarta",
    "Horário (ativ. síncronas)": "19:00-21:00",
    "CH Sem Síncrona": 4,
    "CH Sem Assíncrona": 6,
    "CH Sem": 10,
    "Semanas": 6,
    "Data de início": "03/11/2020",
    "Data de fim": "11/12/2020",
    "Período Recesso": "não se aplica",
    "Meios de comunicação utilizados?": "Teams, M.pdfe TADS",
    "Planos de Ensino": "ds240.pdf",
    "Meses": "nov,dez"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS640",
    "Período": 4,
    "Nome da disciplina": "Redação Técnica",
    "Docente responsável": "Marly de Castro Campos Coati",
    "Contato do.pdfente": "marlycoati@gmail.com",
    "Número de vagas (veteranos/calouros)": 15,
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "terça",
    "Horário (ativ. síncronas)": "19:00-20:00",
    "CH Sem Síncrona": 1,
    "CH Sem Assíncrona": 3,
    "CH Sem": 4,
    "Semanas": 8,
    "Data de início": "09/11/2020",
    "Data de fim": "01/02/2021",
    "Período Recesso": "21/12/20 a 16/01/21; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "Teams, UFPR Virtual e email",
    "Planos de Ensino": "ds640.pdf",
    "Meses": "nov,dez,jan,fev"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS640",
    "Período": 4,
    "Nome da disciplina": "Redação Técnica",
    "Docente responsável": "Marly de Castro Campos Coati",
    "Contato do.pdfente": "marlycoati@gmail.com",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "terça",
    "Horário (ativ. síncronas)": "19:00-20:00",
    "CH Sem Síncrona": 1,
    "CH Sem Assíncrona": 3,
    "CH Sem": 4,
    "Semanas": 8,
    "Data de início": "09/11/2020",
    "Data de fim": "01/02/2021",
    "Período Recesso": "21/12/20 a 16/01/21; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "Teams, UFPR Virtual e email",
    "Planos de Ensino": "ds640.pdf",
    "Meses": "nov,dez,jan,fev"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS142",
    "Período": 4,
    "Nome da disciplina": "Linguagem de Programação Orientada a Objetos II",
    "Docente responsável": "Rafael Romualdo Wandresen",
    "Contato do.pdfente": "rafaelwand@gmail.com",
    "Número de vagas (veteranos/calouros)": 20,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "sexta",
    "Horário (ativ. síncronas)": "19:00-22:00",
    "CH Sem Síncrona": 3,
    "CH Sem Assíncrona": 2,
    "CH Sem": 5,
    "Semanas": 12,
    "Data de início": "03/11/2020",
    "Data de fim": "27/03/2021",
    "Período Recesso": "21/12/20 a 16/01/21; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS",
    "Planos de Ensino": "ds142.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS142",
    "Período": 4,
    "Nome da disciplina": "Linguagem de Programação Orientada a Objetos II",
    "Docente responsável": "Rafael Romualdo Wandresen",
    "Contato do.pdfente": "rafaelwand@gmail.com",
    "Número de vagas (veteranos/calouros)": 40,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "sexta",
    "Horário (ativ. síncronas)": "19:00-22:00",
    "CH Sem Síncrona": 3,
    "CH Sem Assíncrona": 2,
    "CH Sem": 5,
    "Semanas": 12,
    "Data de início": "03/11/2020",
    "Data de fim": "27/03/2021",
    "Período Recesso": "21/12/20 a 16/01/21; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS",
    "Planos de Ensino": "ds142.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS950",
    "Período": 5,
    "Nome da disciplina": "TCC 1",
    "Docente responsável": "Docentes núcleo duro",
    "Contato do.pdfente": "-",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 90,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 6,
    "CH Sem": 6,
    "Semanas": 15,
    "Data de início": "03/11/2020",
    "Data de fim": "01/04/2021",
    "Período Recesso": "21/12/20 a 16/01/21; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "E-mail, Teams e Moodle TADS",
    "Planos de Ensino": "ds950.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS950",
    "Período": 5,
    "Nome da disciplina": "TCC 1",
    "Docente responsável": "Docentes núcleo duro",
    "Contato do.pdfente": "-",
    "Número de vagas (veteranos/calouros)": 60,
    "Carga Horária da disciplina": 90,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 6,
    "CH Sem": 6,
    "Semanas": 15,
    "Data de início": "03/11/2020",
    "Data de fim": "01/04/2021",
    "Período Recesso": "21/12/20 a 16/01/21; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "E-mail, Teams e Moodle TADS",
    "Planos de Ensino": "ds950.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS250",
    "Período": 5,
    "Nome da disciplina": "Interação Humano Computador N",
    "Docente responsável": "Sandramara K P Soares",
    "Contato do.pdfente": "sskusano@ufpr.br",
    "Número de vagas (veteranos/calouros)": 15,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "terça",
    "Horário (ativ. síncronas)": "19:00-21:00",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 4,
    "CH Sem": 6,
    "Semanas": 10,
    "Data de início": "03/11/2020",
    "Data de fim": "10/02/2020",
    "Período Recesso": "21/12/20 a 16/01/21; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS, Siga (email) e whatsapp",
    "Planos de Ensino": "ds250.pdf",
    "Meses": "nov,dez,jan,fev"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS250",
    "Período": 5,
    "Nome da disciplina": "Interação Humano Computador N",
    "Docente responsável": "Sandramara K P Soares",
    "Contato do.pdfente": "sskusano@ufpr.br",
    "Número de vagas (veteranos/calouros)": 35,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "terça",
    "Horário (ativ. síncronas)": "19:00-21:00",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 4,
    "CH Sem": 6,
    "Semanas": 10,
    "Data de início": "03/11/2020",
    "Data de fim": "10/02/2020",
    "Período Recesso": "21/12/20 a 16/01/21; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS, Siga (email) e whatsapp",
    "Planos de Ensino": "ds250.pdf",
    "Meses": "nov,dez,jan,fev"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS151",
    "Período": 5,
    "Nome da disciplina": "Desenvolvimento para Dispositívos Móveis",
    "Docente responsável": "Alessandro Brawerman",
    "Contato do.pdfente": "brawerman@ufpr.br",
    "Número de vagas (veteranos/calouros)": 40,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "terça",
    "Horário (ativ. síncronas)": "16:30-18:30",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 3.5,
    "CH Sem": 5.5,
    "Semanas": 11,
    "Data de início": "10/11/2020",
    "Data de fim": "09/03/2021",
    "Período Recesso": "19/12/2020 a 01/02/2021; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "Teams e e-mail",
    "Planos de Ensino": "ds151_t.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS151",
    "Período": 5,
    "Nome da disciplina": "Desenvolvimento para Dispositívos Móveis",
    "Docente responsável": "Alexander Kutzke",
    "Contato do.pdfente": "alexander@ufpr.br",
    "Número de vagas (veteranos/calouros)": 40,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "quinta",
    "Horário (ativ. síncronas)": "19:00-21:00",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 2,
    "CH Sem": 4,
    "Semanas": 15,
    "Data de início": "03/11/2020",
    "Data de fim": "27/03/2021",
    "Período Recesso": "21/12/20 a 16/01/21; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS, Telegram, email e Gitlab; Dia de atividades síncronas pode ser outro",
    "Planos de Ensino": "ds151_n.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS650",
    "Período": 5,
    "Nome da disciplina": "Gestão de Empresas",
    "Docente responsável": "Paulo Eduardo Sobreira Moraes",
    "Contato do.pdfente": "paulomoraes@ufpr.br",
    "Número de vagas (veteranos/calouros)": 10,
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 5,
    "CH Sem": 5,
    "Semanas": 6,
    "Data de início": "03/11/2020",
    "Data de fim": "08/12/2020",
    "Período Recesso": "não se aplica",
    "Meios de comunicação utilizados?": "Teams, moodle Tads, e-mail e whatsapp",
    "Planos de Ensino": "ds650.pdf",
    "Meses": "nov,dez"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS650",
    "Período": 5,
    "Nome da disciplina": "Gestão de Empresas",
    "Docente responsável": "Paulo Eduardo Sobreira Moraes",
    "Contato do.pdfente": "paulomoraes@ufpr.br",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 5,
    "CH Sem": 5,
    "Semanas": 6,
    "Data de início": "03/11/2020",
    "Data de fim": "08/12/2020",
    "Período Recesso": "não se aplica",
    "Meios de comunicação utilizados?": "Teams, moodle Tads, e-mail e whatsapp",
    "Planos de Ensino": "ds650.pdf",
    "Meses": "nov,dez"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS150",
    "Período": 5,
    "Nome da disciplina": "Desenvolvimento de Aplicações Corporativas",
    "Docente responsável": "Razer Anthom Nizer Rojas Montaño",
    "Contato do.pdfente": "razer@ufpr.br",
    "Número de vagas (veteranos/calouros)": 10,
    "Carga Horária da disciplina": 75,
    "Dias da semana (ativ. síncronas)": "quarta",
    "Horário (ativ. síncronas)": "19:00-21:00",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 7,
    "CH Sem": 9.35,
    "Semanas": 9,
    "Data de início": "20/01/2021",
    "Data de fim": "24/03/2021",
    "Período Recesso": "até 19/01; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "Teams, moodle Tads, e-mail",
    "Planos de Ensino": "ds150.pdf",
    "Meses": "jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS150",
    "Período": 5,
    "Nome da disciplina": "Desenvolvimento de Aplicações Corporativas",
    "Docente responsável": "Razer Anthom Nizer Rojas Montaño",
    "Contato do.pdfente": "razer@ufpr.br",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 75,
    "Dias da semana (ativ. síncronas)": "quarta",
    "Horário (ativ. síncronas)": "19:00-21:00",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 7,
    "CH Sem": 9.35,
    "Semanas": 9,
    "Data de início": "20/01/2021",
    "Data de fim": "24/03/2021",
    "Período Recesso": "até 19/01; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "Teams, moodle Tads, e-mail",
    "Planos de Ensino": "ds150.pdf",
    "Meses": "jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS662",
    "Período": 6,
    "Nome da disciplina": "Ferramentas de Qualidade",
    "Docente responsável": "Paulo Eduardo Sobreira Moraes",
    "Contato do.pdfente": "paulomoraes@ufpr.br",
    "Número de vagas (veteranos/calouros)": 10,
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 5,
    "CH Sem": 5,
    "Semanas": 6,
    "Data de início": "03/11/2020",
    "Data de fim": "08/12/2020",
    "Período Recesso": "não se aplica",
    "Meios de comunicação utilizados?": "Teams, moodle Tads, e-mail e whatsapp",
    "Planos de Ensino": "ds662.pdf",
    "Meses": "nov,dez"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS662",
    "Período": 6,
    "Nome da disciplina": "Ferramentas de Qualidade",
    "Docente responsável": "Paulo Eduardo Sobreira Moraes",
    "Contato do.pdfente": "paulomoraes@ufpr.br",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 5,
    "CH Sem": 5,
    "Semanas": 6,
    "Data de início": "03/11/2020",
    "Data de fim": "08/12/2020",
    "Período Recesso": "não se aplica",
    "Meios de comunicação utilizados?": "Teams, moodle Tads, e-mail e whatsapp",
    "Planos de Ensino": "ds662.pdf",
    "Meses": "nov,dez"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS660",
    "Período": 6,
    "Nome da disciplina": "Empreendedorismo e inovação",
    "Docente responsável": "Paulo Eduardo Sobreira Moraes",
    "Contato do.pdfente": "paulomoraes@ufpr.br",
    "Número de vagas (veteranos/calouros)": 10,
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 5,
    "CH Sem": 5,
    "Semanas": 6,
    "Data de início": "03/11/2020",
    "Data de fim": "08/12/2020",
    "Período Recesso": "não se aplica",
    "Meios de comunicação utilizados?": "Teams, moodle Tads, e-mail e whatsapp",
    "Planos de Ensino": "ds660.pdf",
    "Meses": "nov,dez"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS660",
    "Período": 6,
    "Nome da disciplina": "Empreendedorismo e inovação",
    "Docente responsável": "Paulo Eduardo Sobreira Moraes",
    "Contato do.pdfente": "paulomoraes@ufpr.br",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 5,
    "CH Sem": 5,
    "Semanas": 6,
    "Data de início": "03/11/2020",
    "Data de fim": "08/12/2020",
    "Período Recesso": "não se aplica",
    "Meios de comunicação utilizados?": "Teams, moodle Tads, e-mail e whatsapp",
    "Planos de Ensino": "ds660.pdf",
    "Meses": "nov,dez"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS260",
    "Período": 6,
    "Nome da disciplina": "Governança de TI",
    "Docente responsável": "Luiz Antônio Pereira Neves",
    "Contato do.pdfente": "neves@ufpr.br",
    "Número de vagas (veteranos/calouros)": 10,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "segunda",
    "Horário (ativ. síncronas)": "19:00-20:00",
    "CH Sem Síncrona": 1,
    "CH Sem Assíncrona": 4,
    "CH Sem": 5,
    "Semanas": 12,
    "Data de início": "03/11/2020",
    "Data de fim": "08/03/2020",
    "Período Recesso": "21/12/20 a 16/01/21; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "Teams, moodle Tads, e-mail e whatsapp",
    "Planos de Ensino": "ds260.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS260",
    "Período": 6,
    "Nome da disciplina": "Governança de TI",
    "Docente responsável": "Luiz Antônio Pereira Neves",
    "Contato do.pdfente": "neves@ufpr.br",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "segunda",
    "Horário (ativ. síncronas)": "19:00-20:00",
    "CH Sem Síncrona": 1,
    "CH Sem Assíncrona": 4,
    "CH Sem": 5,
    "Semanas": 12,
    "Data de início": "03/11/2020",
    "Data de fim": "08/03/2020",
    "Período Recesso": "21/12/20 a 16/01/21; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "Teams, moodle Tads, e-mail e whatsapp",
    "Planos de Ensino": "ds260.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS960",
    "Período": 6,
    "Nome da disciplina": "TCC 2",
    "Docente responsável": "Docentes núcleo duro",
    "Contato do.pdfente": "-",
    "Número de vagas (veteranos/calouros)": 60,
    "Carga Horária da disciplina": 150,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 10,
    "CH Sem": 10,
    "Semanas": 10,
    "Data de início": "03/11/2020",
    "Data de fim": "01/04/2021",
    "Período Recesso": "21/12/20 a 16/01/21; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "E-mail, Teams e Moodle TADS",
    "Planos de Ensino": "ds960.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS960",
    "Período": 6,
    "Nome da disciplina": "TCC 2",
    "Docente responsável": "Docentes núcleo duro",
    "Contato do.pdfente": "-",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 150,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 10,
    "CH Sem": 10,
    "Semanas": 15,
    "Data de início": "03/11/2020",
    "Data de fim": "01/04/2021",
    "Período Recesso": "21/12/20 a 16/01/21; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "E-mail, Teams e Moodle TADS",
    "Planos de Ensino": "ds960.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "TI164",
    "Período": 6,
    "Nome da disciplina": "Estágio Obrigatório",
    "Docente responsável": "Docentes núcleo duro",
    "Contato do.pdfente": "-",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 240,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 16,
    "CH Sem": 16,
    "Semanas": 15,
    "Data de início": "03/11/2020",
    "Data de fim": "01/04/2021",
    "Período Recesso": "21/12/20 a 16/01/21; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "E-mail, Teams e Moodle TADS",
    "Planos de Ensino": "ti164.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "TI164",
    "Período": 6,
    "Nome da disciplina": "Estágio Obrigatório",
    "Docente responsável": "Docentes núcleo duro",
    "Contato do.pdfente": "-",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 240,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 16,
    "CH Sem": 16,
    "Semanas": 15,
    "Data de início": "03/11/2020",
    "Data de fim": "01/04/2021",
    "Período Recesso": "21/12/20 a 16/01/21; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "E-mail, Teams e Moodle TADS",
    "Planos de Ensino": "ti164.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "TI163",
    "Período": 6,
    "Nome da disciplina": "Laboratório de Desenvolvimento de Sistemas",
    "Docente responsável": "Docentes núcleo duro",
    "Contato do.pdfente": "-",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 195,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 13,
    "CH Sem": 13,
    "Semanas": 15,
    "Data de início": "03/11/2020",
    "Data de fim": "01/04/2021",
    "Período Recesso": "21/12/20 a 16/01/21; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "E-mail, Teams e Moodle TADS",
    "Planos de Ensino": "ti163.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "TI163",
    "Período": 6,
    "Nome da disciplina": "Laboratório de Desenvolvimento de Sistemas",
    "Docente responsável": "Docentes núcleo duro",
    "Contato do.pdfente": "-",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 195,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 13,
    "CH Sem": 13,
    "Semanas": 15,
    "Data de início": "03/11/2020",
    "Data de fim": "01/04/2021",
    "Período Recesso": "21/12/20 a 16/01/21; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "E-mail, Teams e Moodle TADS",
    "Planos de Ensino": "ti163.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "TI166",
    "Período": 6,
    "Nome da disciplina": "Trabalho de Conclusão de Curso",
    "Docente responsável": "Docentes núcleo duro",
    "Contato do.pdfente": "-",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 15,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 1,
    "CH Sem": 1,
    "Semanas": 15,
    "Data de início": "03/11/2020",
    "Data de fim": "01/04/2021",
    "Período Recesso": "21/12/20 a 16/01/21; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "E-mail, Teams e Moodle TADS",
    "Planos de Ensino": "ti166.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "TI166",
    "Período": 6,
    "Nome da disciplina": "Trabalho de Conclusão de Curso",
    "Docente responsável": "Docentes núcleo duro",
    "Contato do.pdfente": "-",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 15,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 1,
    "CH Sem": 1,
    "Semanas": 15,
    "Data de início": "03/11/2020",
    "Data de fim": "01/04/2021",
    "Período Recesso": "21/12/20 a 16/01/21; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "E-mail, Teams e Moodle TADS",
    "Planos de Ensino": "ti166.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "NI147",
    "Período": "Op",
    "Nome da disciplina": "Relacionamento Interpessoal",
    "Docente responsável": "Paulo Eduardo Sobreira Moraes",
    "Contato do.pdfente": "paulomoraes@ufpr.br",
    "Número de vagas (veteranos/calouros)": 10,
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 5,
    "CH Sem": 5,
    "Semanas": 6,
    "Data de início": "03/11/2020",
    "Data de fim": "08/12/2020",
    "Período Recesso": "não se aplica",
    "Meios de comunicação utilizados?": "Teams, moodle Tads, e-mail e whatsapp",
    "Planos de Ensino": "ni147.pdf",
    "Meses": "nov,dez"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "NI147",
    "Período": "Op",
    "Nome da disciplina": "Relacionamento Interpessoal",
    "Docente responsável": "Paulo Eduardo Sobreira Moraes",
    "Contato do.pdfente": "paulomoraes@ufpr.br",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 5,
    "CH Sem": 5,
    "Semanas": 6,
    "Data de início": "03/11/2020",
    "Data de fim": "08/12/2020",
    "Período Recesso": "não se aplica",
    "Meios de comunicação utilizados?": "Teams, moodle Tads, e-mail e whatsapp",
    "Planos de Ensino": "ni147.pdf",
    "Meses": "nov,dez"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS878",
    "Período": "Op",
    "Nome da disciplina": "Processamento Digital de Imagens",
    "Docente responsável": "Luiz Antônio Pereira Neves",
    "Contato do.pdfente": "neves@ufpr.br",
    "Número de vagas (veteranos/calouros)": 10,
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "segunda",
    "Horário (ativ. síncronas)": "21:00-22:00",
    "CH Sem Síncrona": 1,
    "CH Sem Assíncrona": 1.5,
    "CH Sem": 2.5,
    "Semanas": 12,
    "Data de início": "03/11/2020",
    "Data de fim": "08/03/2020",
    "Período Recesso": "21/12/2020 a 19/01/2021; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "Teams, moodle Tads, e-mail e whatsapp",
    "Planos de Ensino": "ds878.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS878",
    "Período": "Op",
    "Nome da disciplina": "Processamento Digital de Imagens",
    "Docente responsável": "Luiz Antônio Pereira Neves",
    "Contato do.pdfente": "neves@ufpr.br",
    "Número de vagas (veteranos/calouros)": 20,
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "segunda",
    "Horário (ativ. síncronas)": "21:00-22:00",
    "CH Sem Síncrona": 1,
    "CH Sem Assíncrona": 1.5,
    "CH Sem": 2.5,
    "Semanas": 12,
    "Data de início": "03/11/2020",
    "Data de fim": "08/03/2020",
    "Período Recesso": "21/12/2020 a 19/01/2021; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "Teams, moodle Tads, e-mail e whatsapp",
    "Planos de Ensino": "ds878.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS803",
    "Período": "Op",
    "Nome da disciplina": "Inteligência Artificial Aplicada I",
    "Docente responsável": "Roberto Tadeu Raittz",
    "Contato do.pdfente": "raittz@ufpr.br",
    "Número de vagas (veteranos/calouros)": 10,
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "quarta",
    "Horário (ativ. síncronas)": "16:30-17:30",
    "CH Sem Síncrona": 1,
    "CH Sem Assíncrona": 4,
    "CH Sem": 5,
    "Semanas": 6,
    "Data de início": "03/11/2020",
    "Data de fim": "27/03/2021",
    "Período Recesso": "16/11/2020 a 16/01/2021; 01/02/2021 a 06/03/2021",
    "Meios de comunicação utilizados?": "Teams, moodle Tads, e-mail e google drive",
    "Planos de Ensino": "ds803.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS803",
    "Período": "Op",
    "Nome da disciplina": "Inteligência Artificial Aplicada I",
    "Docente responsável": "Roberto Tadeu Raittz",
    "Contato do.pdfente": "raittz@ufpr.br",
    "Número de vagas (veteranos/calouros)": 20,
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "quarta",
    "Horário (ativ. síncronas)": "16:30-17:30",
    "CH Sem Síncrona": 1,
    "CH Sem Assíncrona": 4,
    "CH Sem": 5,
    "Semanas": 6,
    "Data de início": "03/11/2020",
    "Data de fim": "27/03/2021",
    "Período Recesso": "16/11/2020 a 16/01/2021; 01/02/2021 a 06/03/2021",
    "Meios de comunicação utilizados?": "Teams, moodle Tads, e-mail e google drive",
    "Planos de Ensino": "ds803.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS875",
    "Período": "Op",
    "Nome da disciplina": "Inglês Técnico",
    "Docente responsável": "Juliana Passos",
    "Contato do.pdfente": "julianapassos@ufpr.br",
    "Número de vagas (veteranos/calouros)": 20,
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 5,
    "CH Sem": 5,
    "Semanas": 6,
    "Data de início": "01/02/2021",
    "Data de fim": "26/03/2021",
    "Período Recesso": "até 31/01; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "UFPR Virtual, e-mail",
    "Planos de Ensino": "ds875.pdf",
    "Meses": "fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS875",
    "Período": "Op",
    "Nome da disciplina": "Inglês Técnico",
    "Docente responsável": "Juliana Passos",
    "Contato do.pdfente": "julianapassos@ufpr.br",
    "Número de vagas (veteranos/calouros)": 40,
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 5,
    "CH Sem": 5,
    "Semanas": 6,
    "Data de início": "01/02/2021",
    "Data de fim": "26/03/2021",
    "Período Recesso": "até 31/01; 15/02/21 a 20/02/21",
    "Meios de comunicação utilizados?": "UFPR Virtual, e-mail",
    "Planos de Ensino": "ds875.pdf",
    "Meses": "fev,mar"
  }
]

/*

[
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS010",
    "Período": 1,
    "Nome da disciplina": "ADMINISTRAÇÃO DE SISTEMAS",
    "Docente responsável": "Mauro Castro",
    "Contato do.pdfente": "mauro.castro@ufpr.br",
    "Número de vagas (veteranos/calouros)": "20(5/15)",
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "quarta",
    "Horário (ativ. síncronas)": "16:30-17:30",
    "CH Sem Síncrona": 1,
    "CH Sem Assíncrona": 3,
    "CH Sem": 4,
    "Semanas": 15,
    "Data de início": "03/11/2020",
    "Data de fim": "27/03/2021",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS ou UFPR Virtual e E-mail",
    "Planos de Ensino": "ds010_t.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS010",
    "Período": 1,
    "Nome da disciplina": "ADMINISTRAÇÃO DE SISTEMAS",
    "Docente responsável": "Mauro Castro",
    "Contato do.pdfente": "mauro.castro@ufpr.br",
    "Número de vagas (veteranos/calouros)": "40(5/35)",
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "quarta",
    "Horário (ativ. síncronas)": "21:00-22:00",
    "CH Sem Síncrona": 1,
    "CH Sem Assíncrona": 3,
    "CH Sem": 4,
    "Semanas": 15,
    "Data de início": "03/11/2020",
    "Data de fim": "27/03/2021",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS ou UFPR Virtual e E-mail",
    "Planos de Ensino": "ds010_n.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS211",
    "Período": 1,
    "Nome da disciplina": "Sistemas de Informação T",
    "Docente responsável": "Mario de Paula Soares Filho",
    "Contato do.pdfente": "paulasoares@ufpr.br",
    "Número de vagas (veteranos/calouros)": "30(5/25)",
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "segunda",
    "Horário (ativ. síncronas)": "19:00-20:00",
    "CH Sem Síncrona": 1,
    "CH Sem Assíncrona": 2,
    "CH Sem": 3,
    "Semanas": 10,
    "Data de início": "03/11/2020",
    "Data de fim": "27/03/2021",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS, Siga e whatsapp,youtube",
    "Planos de Ensino": "ds211.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS211",
    "Período": 1,
    "Nome da disciplina": "Sistemas de Informação N",
    "Docente responsável": "Mario de Paula Soares Filho",
    "Contato do.pdfente": "paulasoares@ufpr.br",
    "Número de vagas (veteranos/calouros)": "70(5/65)",
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "segunda",
    "Horário (ativ. síncronas)": "19:00-20:00",
    "CH Sem Síncrona": 1,
    "CH Sem Assíncrona": 2,
    "CH Sem": 3,
    "Semanas": 10,
    "Data de início": "03/11/2020",
    "Data de fim": "27/03/2021",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS, Siga e whatsapp,youtube",
    "Planos de Ensino": "ds211.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS110",
    "Período": 1,
    "Nome da disciplina": "Proj de Algoritmos e Prat de Programação",
    "Docente responsável": "Luiz Antonio Passos Cardoso",
    "Contato do.pdfente": "lcardoscx@gmail.com",
    "Número de vagas (veteranos/calouros)": "50(5/45)",
    "Carga Horária da disciplina": 90,
    "Dias da semana (ativ. síncronas)": "quinta",
    "Horário (ativ. síncronas)": "19:00-23:00",
    "CH Sem Síncrona": 4,
    "CH Sem Assíncrona": 2,
    "CH Sem": 6,
    "Semanas": 15,
    "Data de início": "03/11/2020",
    "Data de fim": "25/03/2021",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "Teams, UFPR Virtual e email",
    "Planos de Ensino": "ds110_t.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS110",
    "Período": 1,
    "Nome da disciplina": "Proj de Algoritmos e Prat de Programação",
    "Docente responsável": "Luiz Antonio Passos Cardoso",
    "Contato do.pdfente": "lcardoscx@gmail.com",
    "Número de vagas (veteranos/calouros)": "50(5/45)",
    "Carga Horária da disciplina": 90,
    "Dias da semana (ativ. síncronas)": "quinta",
    "Horário (ativ. síncronas)": "14:30-18:30",
    "CH Sem Síncrona": 4,
    "CH Sem Assíncrona": 2,
    "CH Sem": 6,
    "Semanas": 15,
    "Data de início": "03/11/2020",
    "Data de fim": "25/03/2021",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "Teams, UFPR Virtual e email",
    "Planos de Ensino": "ds110_n.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS011",
    "Período": 1,
    "Nome da disciplina": "Introdução Arquitetura de Computadores",
    "Docente responsável": "Pedro R. Torres Jr.",
    "Contato do.pdfente": "pedro.torres@ufpr.br",
    "Número de vagas (veteranos/calouros)": "80(5/75)",
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "terça",
    "Horário (ativ. síncronas)": "19:00-20:00",
    "CH Sem Síncrona": 1,
    "CH Sem Assíncrona": 7,
    "CH Sem": 8,
    "Semanas": 7.5,
    "Data de início": "03/11/2020",
    "Data de fim": "09/02/2021",
    "Período Recesso": "19/12/2020 a 03/02/2021",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS, SIGA e Telegram",
    "Planos de Ensino": "ds011.pdf",
    "Meses": "nov,dez,jan,fev"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS011",
    "Período": 1,
    "Nome da disciplina": "Introdução Arquitetura de Computadores",
    "Docente responsável": "Pedro R. Torres Jr.",
    "Contato do.pdfente": "pedro.torres@ufpr.br",
    "Número de vagas (veteranos/calouros)": "80(5/75)",
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "terça",
    "Horário (ativ. síncronas)": "18:00-19:00",
    "CH Sem Síncrona": 1,
    "CH Sem Assíncrona": 7,
    "CH Sem": 8,
    "Semanas": 7.5,
    "Data de início": "03/11/2020",
    "Data de fim": "09/02/2021",
    "Período Recesso": "19/12/2020 a 03/02/2021",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS, SIGA e Telegram",
    "Planos de Ensino": "ds011.pdf",
    "Meses": "nov,dez,jan,fev"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS121",
    "Período": 2,
    "Nome da disciplina": "Linguagem de Programação",
    "Docente responsável": "Dieval Guizelini",
    "Contato do.pdfente": "dieval@ufpr.br",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 75,
    "Dias da semana (ativ. síncronas)": "segunda",
    "Horário (ativ. síncronas)": "19:00-21:00",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 4,
    "CH Sem": 6,
    "Semanas": 13,
    "Data de início": "09/11/2020",
    "Data de fim": "27/03/2021",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "Teams, moodle, farmaalg",
    "Planos de Ensino": "ds121.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS121",
    "Período": 2,
    "Nome da disciplina": "Linguagem de Programação",
    "Docente responsável": "Dieval Guizelini",
    "Contato do.pdfente": "dieval@ufpr.br",
    "Número de vagas (veteranos/calouros)": 60,
    "Carga Horária da disciplina": 75,
    "Dias da semana (ativ. síncronas)": "segunda",
    "Horário (ativ. síncronas)": "19:00-21:00",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 4,
    "CH Sem": 6,
    "Semanas": 13,
    "Data de início": "09/11/2020",
    "Data de fim": "27/03/2021",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "Teams, moodle, farmaalg",
    "Planos de Ensino": "ds121.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS220",
    "Período": 2,
    "Nome da disciplina": "Análise e Projetos de Sistemas I T",
    "Docente responsável": "Sandramara K P Soares",
    "Contato do.pdfente": "sskusano@ufpr.br",
    "Número de vagas (veteranos/calouros)": 40,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "segunda",
    "Horário (ativ. síncronas)": "14:30-16:30",
    "CH Sem Síncrona": 4,
    "CH Sem Assíncrona": 4,
    "CH Sem": 8,
    "Semanas": 8,
    "Data de início": "04/11/2020",
    "Data de fim": "27/01/2021",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS, Siga (email) e whatsapp",
    "Planos de Ensino": "ds220_t.pdf",
    "Meses": "nov,dez,jan"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS220",
    "Período": 2,
    "Nome da disciplina": "Análise e Projetos de Sistemas I T",
    "Docente responsável": "Sandramara K P Soares",
    "Contato do.pdfente": "sskusano@ufpr.br",
    "Número de vagas (veteranos/calouros)": 40,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "quarta",
    "Horário (ativ. síncronas)": "14:30-16:30",
    "CH Sem Síncrona": 4,
    "CH Sem Assíncrona": 4,
    "CH Sem": 8,
    "Semanas": 8,
    "Data de início": "04/11/2020",
    "Data de fim": "27/01/2021",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS, Siga (email) e whatsapp",
    "Planos de Ensino": "ds220_t.pdf",
    "Meses": "nov,dez,jan"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS220",
    "Período": 2,
    "Nome da disciplina": "Análise e Projetos de Sistemas I - N",
    "Docente responsável": "Jaime Wojciechowski",
    "Contato do.pdfente": "jaimewo@ufpr.br",
    "Número de vagas (veteranos/calouros)": 60,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "terça",
    "Horário (ativ. síncronas)": "19:00-21:00",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 6,
    "CH Sem": 8,
    "Semanas": 9,
    "Data de início": "03/11/2020",
    "Data de fim": "23/01/2020",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "Teams, UFPR Virtual",
    "Planos de Ensino": "ds220_n.pdf",
    "Meses": "nov,dez,jan"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS221",
    "Período": 2,
    "Nome da disciplina": "Modelagem de negócios T",
    "Docente responsável": "Mario de Paula Soares Filho",
    "Contato do.pdfente": "paulasoares@ufpr.br",
    "Número de vagas (veteranos/calouros)": 50,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "terça",
    "Horário (ativ. síncronas)": "14:30-16:30",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 4,
    "CH Sem": 6,
    "Semanas": 10,
    "Data de início": "03/11/2020",
    "Data de fim": "27/03/2021",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS, Siga e whatsapp,youtube",
    "Planos de Ensino": "ds221.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS221",
    "Período": 2,
    "Nome da disciplina": "Modelagem de negócios N",
    "Docente responsável": "Mario de Paula Soares Filho",
    "Contato do.pdfente": "paulasoares@ufpr.br",
    "Número de vagas (veteranos/calouros)": 50,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "quarta",
    "Horário (ativ. síncronas)": "20:00-22:00",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 4,
    "CH Sem": 6,
    "Semanas": 10,
    "Data de início": "03/11/2020",
    "Data de fim": "27/03/2021",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS, Siga e whatsapp,youtube",
    "Planos de Ensino": "ds221.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS122",
    "Período": 2,
    "Nome da disciplina": "Desenvolvimento Web 1",
    "Docente responsável": "Alexander Kutzke",
    "Contato do.pdfente": "alexander@ufpr.br",
    "Número de vagas (veteranos/calouros)": 25,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "sexta",
    "Horário (ativ. síncronas)": "19:00-21:00",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 4.6,
    "CH Sem": 4.6,
    "Semanas": 9,
    "Data de início": "18/01/2021",
    "Data de fim": "27/03/2021",
    "Período Recesso": "carnaval",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS, Telegram, email e Gitlab; Dia de atividades síncronas pode ser outro",
    "Planos de Ensino": "ds122;pdf",
    "Meses": "jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS122",
    "Período": 2,
    "Nome da disciplina": "Desenvolvimento Web 1",
    "Docente responsável": "Alexander Kutzke",
    "Contato do.pdfente": "alexander@ufpr.br",
    "Número de vagas (veteranos/calouros)": 55,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "sexta",
    "Horário (ativ. síncronas)": "19:00-21:00",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 4.6,
    "CH Sem": 6.6,
    "Semanas": 9,
    "Data de início": "18/01/2021",
    "Data de fim": "27/03/2021",
    "Período Recesso": "carnaval",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS, Telegram, email e Gitlab; Dia de atividades síncronas pode ser outro",
    "Planos de Ensino": "ds122;pdf",
    "Meses": "jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS020",
    "Período": 2,
    "Nome da disciplina": "Redes de Computadores",
    "Docente responsável": "Pedro R. Torres Jr.",
    "Contato do.pdfente": "pedro.torres@ufpr.br",
    "Número de vagas (veteranos/calouros)": 10,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "quarta",
    "Horário (ativ. síncronas)": "19:00-20:00",
    "CH Sem Síncrona": 1,
    "CH Sem Assíncrona": 7,
    "CH Sem": 8,
    "Semanas": 7.5,
    "Data de início": "03/02/2021",
    "Data de fim": "24/03/2021",
    "Período Recesso": "19/12/2020 a 03/02/2021",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS, SIGA e Telegram",
    "Planos de Ensino": "ds020.pdf",
    "Meses": "fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48B",
    "Código da disciplina": "DS020",
    "Período": 2,
    "Nome da disciplina": "Redes de Computadores",
    "Docente responsável": "Pedro R. Torres Jr.",
    "Contato do.pdfente": "pedro.torres@ufpr.br",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "quarta",
    "Horário (ativ. síncronas)": "18:00-19:00",
    "CH Sem Síncrona": 1,
    "CH Sem Assíncrona": 7,
    "CH Sem": 8,
    "Semanas": 7.5,
    "Data de início": "03/02/2021",
    "Data de fim": "24/03/2021",
    "Período Recesso": "19/12/2020 a 03/02/2021",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS, SIGA e Telegram",
    "Planos de Ensino": "ds020.pdf",
    "Meses": "fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS230",
    "Período": 3,
    "Nome da disciplina": "Análise e Projetos de Sistemas II - N",
    "Docente responsável": "Jaime Wojciechowski",
    "Contato do.pdfente": "jaimewo@ufpr.br",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 90,
    "Dias da semana (ativ. síncronas)": "terça",
    "Horário (ativ. síncronas)": "21:00-23:00",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 10,
    "CH Sem": 12,
    "Semanas": 9,
    "Data de início": "03/11/2020",
    "Data de fim": "23/01/2020",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "Teams, UFPR Virtual",
    "Planos de Ensino": "ds230.pdf",
    "Meses": "nov,dez,jan"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS230",
    "Período": 3,
    "Nome da disciplina": "Análise e Projetos de Sistemas II - N",
    "Docente responsável": "Jaime Wojciechowski",
    "Contato do.pdfente": "jaimewo@ufpr.br",
    "Número de vagas (veteranos/calouros)": 50,
    "Carga Horária da disciplina": 90,
    "Dias da semana (ativ. síncronas)": "terça",
    "Horário (ativ. síncronas)": "21:00-23:00",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 10,
    "CH Sem": 12,
    "Semanas": 9,
    "Data de início": "03/11/2020",
    "Data de fim": "23/01/2020",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "Teams, UFPR Virtual",
    "Planos de Ensino": "ds230.pdf",
    "Meses": "nov,dez,jan"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS130",
    "Período": 3,
    "Nome da disciplina": "Estruturas de Dados I",
    "Docente responsável": "Andreia de Jesus",
    "Contato do.pdfente": "andreia.jesus@ufpr.br",
    "Número de vagas (veteranos/calouros)": 20,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 4,
    "CH Sem": 4,
    "Semanas": 15,
    "Data de início": "03/11/2020",
    "Data de fim": "27/03/2021",
    "Período Recesso": "19/12/2020 a 01/02/2021",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS e email; As atividades síncronas são para dúvidas (se necessário) e apresentação de trabalhos. Serão marcadas diretamente com a turma. ",
    "Planos de Ensino": "ds130.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS130",
    "Período": 3,
    "Nome da disciplina": "Estruturas de Dados I",
    "Docente responsável": "Andreia de Jesus",
    "Contato do.pdfente": "andreia.jesus@ufpr.br",
    "Número de vagas (veteranos/calouros)": 40,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 4,
    "CH Sem": 4,
    "Semanas": 15,
    "Data de início": "03/11/2020",
    "Data de fim": "27/03/2021",
    "Período Recesso": "19/12/2020 a 01/02/2022",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS e email; As atividades síncronas são para dúvidas (se necessário) e apresentação de trabalhos. Serão marcadas diretamente com a turma. ",
    "Planos de Ensino": "ds130.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS622",
    "Período": 3,
    "Nome da disciplina": "Comportamento Organizacional",
    "Docente responsável": "Maria Valéria da Costa",
    "Contato do.pdfente": "valerialua27@gmail.com",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 45,
    "Dias da semana (ativ. síncronas)": "quarta",
    "Horário (ativ. síncronas)": "14:30-16:30",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 3,
    "CH Sem": 5,
    "Semanas": 9,
    "Data de início": "03/11/2020",
    "Data de fim": "03/03/2021",
    "Período Recesso": "21/12/2020 a 31/01/2021",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS ou UFPR Virtual e E-mail SIGA",
    "Planos de Ensino": "ds622_t.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS622",
    "Período": 3,
    "Nome da disciplina": "Comportamento Organizacional",
    "Docente responsável": "Maria Valéria da Costa",
    "Contato do.pdfente": "valerialua27@gmail.com",
    "Número de vagas (veteranos/calouros)": 60,
    "Carga Horária da disciplina": 45,
    "Dias da semana (ativ. síncronas)": "quarta",
    "Horário (ativ. síncronas)": "19:00-21:00",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 3,
    "CH Sem": 5,
    "Semanas": 9,
    "Data de início": "03/11/2020",
    "Data de fim": "03/03/2021",
    "Período Recesso": "21/12/2020 a 31/01/2021",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS ou UFPR Virtual e E-mail SIGA",
    "Planos de Ensino": "ds622_n.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS131",
    "Período": 3,
    "Nome da disciplina": "Linguagem de Programação Orientada a Objetos I",
    "Docente responsável": "Rafael Romualdo Wandresen",
    "Contato do.pdfente": "rafaelwand@gmail.com",
    "Número de vagas (veteranos/calouros)": 20,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "quinta",
    "Horário (ativ. síncronas)": "19:00-22:00",
    "CH Sem Síncrona": 3,
    "CH Sem Assíncrona": 2,
    "CH Sem": 5,
    "Semanas": 12,
    "Data de início": "03/11/2020",
    "Data de fim": "27/03/2021",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS",
    "Planos de Ensino": "ds131.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS131",
    "Período": 3,
    "Nome da disciplina": "Linguagem de Programação Orientada a Objetos I",
    "Docente responsável": "Rafael Romualdo Wandresen",
    "Contato do.pdfente": "rafaelwand@gmail.com",
    "Número de vagas (veteranos/calouros)": 40,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "quinta",
    "Horário (ativ. síncronas)": "19:00-22:00",
    "CH Sem Síncrona": 3,
    "CH Sem Assíncrona": 2,
    "CH Sem": 5,
    "Semanas": 12,
    "Data de início": "03/11/2020",
    "Data de fim": "27/03/2021",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS",
    "Planos de Ensino": "ds131.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS030",
    "Período": 3,
    "Nome da disciplina": "Sistemas Operacionais",
    "Docente responsável": "Alessandro Brawerman",
    "Contato do.pdfente": "brawerman@ufpr.br",
    "Número de vagas (veteranos/calouros)": 10,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "terça",
    "Horário (ativ. síncronas)": "14:30-16:30",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 3,
    "CH Sem": 5,
    "Semanas": 12,
    "Data de início": "10/11/2020",
    "Data de fim": "16/03/2021",
    "Período Recesso": "19/12/2020 a 01/02/2021",
    "Meios de comunicação utilizados?": "Teams e e-mail",
    "Planos de Ensino": "ds030.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS030",
    "Período": 3,
    "Nome da disciplina": "Sistemas Operacionais",
    "Docente responsável": "Alessandro Brawerman",
    "Contato do.pdfente": "brawerman@ufpr.br",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "terça",
    "Horário (ativ. síncronas)": "14:30-16:30",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 3,
    "CH Sem": 5,
    "Semanas": 12,
    "Data de início": "10/11/2020",
    "Data de fim": "16/03/2021",
    "Período Recesso": "19/12/2020 a 01/02/2021",
    "Meios de comunicação utilizados?": "Teams e e-mail",
    "Planos de Ensino": "ds030.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS630",
    "Período": 3,
    "Nome da disciplina": "Direito Aplicado",
    "Docente responsável": "Silvana Maria Carbonera",
    "Contato do.pdfente": "silvana.carbonera@ufpr.br",
    "Número de vagas (veteranos/calouros)": 10,
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "terça",
    "Horário (ativ. síncronas)": "19:00-21:00",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 3,
    "CH Sem": 5,
    "Semanas": 6,
    "Data de início": "03/11/2020",
    "Data de fim": "11/12/2020",
    "Período Recesso": "não se aplica",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS e SIGA (email)",
    "Planos de Ensino": "ds630.pdf",
    "Meses": "nov,dez"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS630",
    "Período": 3,
    "Nome da disciplina": "Direito Aplicado",
    "Docente responsável": "Silvana Maria Carbonera",
    "Contato do.pdfente": "silvana.carbonera@ufpr.br",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "terça",
    "Horário (ativ. síncronas)": "19:00-21:00",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 3,
    "CH Sem": 5,
    "Semanas": 6,
    "Data de início": "03/11/2020",
    "Data de fim": "11/12/2020",
    "Período Recesso": "não se aplica",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS e SIGA (email)",
    "Planos de Ensino": "ds630.pdf",
    "Meses": "nov,dez"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS340",
    "Período": 4,
    "Nome da disciplina": "BANCO DE DADOS III",
    "Docente responsável": "João Eugenio Marynowski",
    "Contato do.pdfente": "jeugenio@ufpr.br",
    "Número de vagas (veteranos/calouros)": 40,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "quarta",
    "Horário (ativ. síncronas)": "14:30-16:30",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 6,
    "CH Sem": 8,
    "Semanas": "7,5",
    "Data de início": "27/01/2020",
    "Data de fim": "25/03/2020",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS ou UFPR Virtual e E-mail",
    "Planos de Ensino": "ds340.pdf",
    "Meses": "jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS340",
    "Período": 4,
    "Nome da disciplina": "BANCO DE DADOS III",
    "Docente responsável": "João Eugenio Marynowski",
    "Contato do.pdfente": "jeugenio@ufpr.br",
    "Número de vagas (veteranos/calouros)": 40,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "quarta",
    "Horário (ativ. síncronas)": "21:00-23:00",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 6,
    "CH Sem": 8,
    "Semanas": "7,5",
    "Data de início": "27/01/2020",
    "Data de fim": "25/03/2020",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS ou UFPR Virtual e E-mail",
    "Planos de Ensino": "ds340.pdf",
    "Meses": "jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS240",
    "Período": 4,
    "Nome da disciplina": "Engenharia de Software I",
    "Docente responsável": "Rafaela Mantovani Fontana",
    "Contato do.pdfente": "rafaela.fontana@ufpr.br",
    "Número de vagas (veteranos/calouros)": 40,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "terça",
    "Horário (ativ. síncronas)": "16:30-18:30",
    "CH Sem Síncrona": 4,
    "CH Sem Assíncrona": 6,
    "CH Sem": 10,
    "Semanas": 6,
    "Data de início": "03/11/2020",
    "Data de fim": "11/12/2020",
    "Período Recesso": "não se aplica",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS",
    "Planos de Ensino": "ds240.pdf",
    "Meses": "nov,dez"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS240",
    "Período": 4,
    "Nome da disciplina": "Engenharia de Software I",
    "Docente responsável": "Rafaela Mantovani Fontana",
    "Contato do.pdfente": "rafaela.fontana@ufpr.br",
    "Número de vagas (veteranos/calouros)": 40,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "quinta",
    "Horário (ativ. síncronas)": "16:30-18:30",
    "CH Sem Síncrona": 4,
    "CH Sem Assíncrona": 6,
    "CH Sem": 10,
    "Semanas": 6,
    "Data de início": "03/11/2020",
    "Data de fim": "11/12/2020",
    "Período Recesso": "não se aplica",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS",
    "Planos de Ensino": "ds240.pdf",
    "Meses": "nov,dez"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS240",
    "Período": 4,
    "Nome da disciplina": "Engenharia de Software I",
    "Docente responsável": "Rafaela Mantovani Fontana",
    "Contato do.pdfente": "rafaela.fontana@ufpr.br",
    "Número de vagas (veteranos/calouros)": 40,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "segunda",
    "Horário (ativ. síncronas)": "19:00-21:00",
    "CH Sem Síncrona": 4,
    "CH Sem Assíncrona": 6,
    "CH Sem": 10,
    "Semanas": 6,
    "Data de início": "03/11/2020",
    "Data de fim": "11/12/2020",
    "Período Recesso": "não se aplica",
    "Meios de comunicação utilizados?": "Teams, M.pdfe TADS",
    "Planos de Ensino": "ds240.pdf",
    "Meses": "nov,dez"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS240",
    "Período": 4,
    "Nome da disciplina": "Engenharia de Software I",
    "Docente responsável": "Rafaela Mantovani Fontana",
    "Contato do.pdfente": "rafaela.fontana@ufpr.br",
    "Número de vagas (veteranos/calouros)": 40,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "quarta",
    "Horário (ativ. síncronas)": "19:00-21:00",
    "CH Sem Síncrona": 4,
    "CH Sem Assíncrona": 6,
    "CH Sem": 10,
    "Semanas": 6,
    "Data de início": "03/11/2020",
    "Data de fim": "11/12/2020",
    "Período Recesso": "não se aplica",
    "Meios de comunicação utilizados?": "Teams, M.pdfe TADS",
    "Planos de Ensino": "ds240.pdf",
    "Meses": "nov,dez"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS640",
    "Período": 4,
    "Nome da disciplina": "Redação Técnica",
    "Docente responsável": "Marly de Castro Campos Coati",
    "Contato do.pdfente": "marlycoati@gmail.com",
    "Número de vagas (veteranos/calouros)": 15,
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "terça",
    "Horário (ativ. síncronas)": "19:00-20:00",
    "CH Sem Síncrona": 1,
    "CH Sem Assíncrona": 3,
    "CH Sem": 4,
    "Semanas": 8,
    "Data de início": "09/11/2020",
    "Data de fim": "01/02/2021",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "Teams, UFPR Virtual e email",
    "Planos de Ensino": "ds640.pdf",
    "Meses": "nov,dez,jan,fev"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS640",
    "Período": 4,
    "Nome da disciplina": "Redação Técnica",
    "Docente responsável": "Marly de Castro Campos Coati",
    "Contato do.pdfente": "marlycoati@gmail.com",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "terça",
    "Horário (ativ. síncronas)": "19:00-20:00",
    "CH Sem Síncrona": 1,
    "CH Sem Assíncrona": 3,
    "CH Sem": 4,
    "Semanas": 8,
    "Data de início": "09/11/2020",
    "Data de fim": "01/02/2021",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "Teams, UFPR Virtual e email",
    "Planos de Ensino": "ds640.pdf",
    "Meses": "nov,dez,jan,fev"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS142",
    "Período": 4,
    "Nome da disciplina": "Linguagem de Programação Orientada a Objetos II",
    "Docente responsável": "Rafael Romualdo Wandresen",
    "Contato do.pdfente": "rafaelwand@gmail.com",
    "Número de vagas (veteranos/calouros)": 20,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "sexta",
    "Horário (ativ. síncronas)": "19:00-22:00",
    "CH Sem Síncrona": 3,
    "CH Sem Assíncrona": 2,
    "CH Sem": 5,
    "Semanas": 12,
    "Data de início": "03/11/2020",
    "Data de fim": "27/03/2021",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS",
    "Planos de Ensino": "ds142.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS142",
    "Período": 4,
    "Nome da disciplina": "Linguagem de Programação Orientada a Objetos II",
    "Docente responsável": "Rafael Romualdo Wandresen",
    "Contato do.pdfente": "rafaelwand@gmail.com",
    "Número de vagas (veteranos/calouros)": 40,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "sexta",
    "Horário (ativ. síncronas)": "19:00-22:00",
    "CH Sem Síncrona": 3,
    "CH Sem Assíncrona": 2,
    "CH Sem": 5,
    "Semanas": 12,
    "Data de início": "03/11/2020",
    "Data de fim": "27/03/2021",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS",
    "Planos de Ensino": "ds142.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS950",
    "Período": 5,
    "Nome da disciplina": "TCC 1",
    "Docente responsável": "Docentes núcleo duro",
    "Contato do.pdfente": "-",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 90,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 6,
    "CH Sem": 6,
    "Semanas": 15,
    "Data de início": "03/11/2020",
    "Data de fim": "01/04/2021",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "E-mail, Teams e Moodle TADS",
    "Planos de Ensino": "ds950.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS950",
    "Período": 5,
    "Nome da disciplina": "TCC 1",
    "Docente responsável": "Docentes núcleo duro",
    "Contato do.pdfente": "-",
    "Número de vagas (veteranos/calouros)": 60,
    "Carga Horária da disciplina": 90,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 6,
    "CH Sem": 6,
    "Semanas": 15,
    "Data de início": "03/11/2020",
    "Data de fim": "01/04/2021",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "E-mail, Teams e Moodle TADS",
    "Planos de Ensino": "ds950.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS250",
    "Período": 5,
    "Nome da disciplina": "Interação Humano Computador N",
    "Docente responsável": "Sandramara K P Soares",
    "Contato do.pdfente": "sskusano@ufpr.br",
    "Número de vagas (veteranos/calouros)": 15,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "terça",
    "Horário (ativ. síncronas)": "19:00-21:00",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 4,
    "CH Sem": 6,
    "Semanas": 10,
    "Data de início": "03/11/2020",
    "Data de fim": "10/02/2020",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS, Siga (email) e whatsapp",
    "Planos de Ensino": "ds250.pdf",
    "Meses": "nov,dez,jan,fev"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS250",
    "Período": 5,
    "Nome da disciplina": "Interação Humano Computador N",
    "Docente responsável": "Sandramara K P Soares",
    "Contato do.pdfente": "sskusano@ufpr.br",
    "Número de vagas (veteranos/calouros)": 35,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "terça",
    "Horário (ativ. síncronas)": "19:00-21:00",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 4,
    "CH Sem": 6,
    "Semanas": 10,
    "Data de início": "03/11/2020",
    "Data de fim": "10/02/2020",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS, Siga (email) e whatsapp",
    "Planos de Ensino": "ds250.pdf",
    "Meses": "nov,dez,jan,fev"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS151",
    "Período": 5,
    "Nome da disciplina": "Desenvolvimento para Dispositívos Móveis",
    "Docente responsável": "Alessandro Brawerman",
    "Contato do.pdfente": "brawerman@ufpr.br",
    "Número de vagas (veteranos/calouros)": 40,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "terça",
    "Horário (ativ. síncronas)": "16:30-18:30",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 3.5,
    "CH Sem": 5.5,
    "Semanas": 11,
    "Data de início": "10/11/2020",
    "Data de fim": "09/03/2021",
    "Período Recesso": "19/12/2020 a 01/02/2021",
    "Meios de comunicação utilizados?": "Teams e e-mail",
    "Planos de Ensino": "ds151_t",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS151",
    "Período": 5,
    "Nome da disciplina": "Desenvolvimento para Dispositívos Móveis",
    "Docente responsável": "Alexander Kutzke",
    "Contato do.pdfente": "alexander@ufpr.br",
    "Número de vagas (veteranos/calouros)": 40,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "quinta",
    "Horário (ativ. síncronas)": "19:00-21:00",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 2,
    "CH Sem": 4,
    "Semanas": 15,
    "Data de início": "03/11/2020",
    "Data de fim": "27/03/2021",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "Teams, Moodle TADS, Telegram, email e Gitlab; Dia de atividades síncronas pode ser outro",
    "Planos de Ensino": "ds151_n",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS650",
    "Período": 5,
    "Nome da disciplina": "Gestão de Empresas",
    "Docente responsável": "Paulo Eduardo Sobreira Moraes",
    "Contato do.pdfente": "paulomoraes@ufpr.br",
    "Número de vagas (veteranos/calouros)": 10,
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 5,
    "CH Sem": 5,
    "Semanas": 6,
    "Data de início": "03/11/2020",
    "Data de fim": "08/12/2020",
    "Período Recesso": "não se aplica",
    "Meios de comunicação utilizados?": "Teams, moodle Tads, e-mail e whatsapp",
    "Planos de Ensino": "ds650.pdf",
    "Meses": "nov,dez"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS650",
    "Período": 5,
    "Nome da disciplina": "Gestão de Empresas",
    "Docente responsável": "Paulo Eduardo Sobreira Moraes",
    "Contato do.pdfente": "paulomoraes@ufpr.br",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 5,
    "CH Sem": 5,
    "Semanas": 6,
    "Data de início": "03/11/2020",
    "Data de fim": "08/12/2020",
    "Período Recesso": "não se aplica",
    "Meios de comunicação utilizados?": "Teams, moodle Tads, e-mail e whatsapp",
    "Planos de Ensino": "ds650.pdf",
    "Meses": "nov,dez"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS150",
    "Período": 5,
    "Nome da disciplina": "Desenvolvimento de Aplicações Corporativas",
    "Docente responsável": "Razer Anthom Nizer Rojas Montaño",
    "Contato do.pdfente": "razer@ufpr.br",
    "Número de vagas (veteranos/calouros)": 10,
    "Carga Horária da disciplina": 75,
    "Dias da semana (ativ. síncronas)": "quarta",
    "Horário (ativ. síncronas)": "19:00-21:00",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 7,
    "CH Sem": 9.35,
    "Semanas": 9,
    "Data de início": "20/01/2021",
    "Data de fim": "24/03/2021",
    "Período Recesso": "até 19/01",
    "Meios de comunicação utilizados?": "Teams, moodle Tads, e-mail",
    "Planos de Ensino": "ds150.pdf",
    "Meses": "jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS150",
    "Período": 5,
    "Nome da disciplina": "Desenvolvimento de Aplicações Corporativas",
    "Docente responsável": "Razer Anthom Nizer Rojas Montaño",
    "Contato do.pdfente": "razer@ufpr.br",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 75,
    "Dias da semana (ativ. síncronas)": "quarta",
    "Horário (ativ. síncronas)": "19:00-21:00",
    "CH Sem Síncrona": 2,
    "CH Sem Assíncrona": 7,
    "CH Sem": 9.35,
    "Semanas": 9,
    "Data de início": "20/01/2021",
    "Data de fim": "24/03/2021",
    "Período Recesso": "até 19/01",
    "Meios de comunicação utilizados?": "Teams, moodle Tads, e-mail",
    "Planos de Ensino": "ds150.pdf",
    "Meses": "jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS662",
    "Período": 6,
    "Nome da disciplina": "Ferramentas de Qualidade",
    "Docente responsável": "Paulo Eduardo Sobreira Moraes",
    "Contato do.pdfente": "paulomoraes@ufpr.br",
    "Número de vagas (veteranos/calouros)": 10,
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 5,
    "CH Sem": 5,
    "Semanas": 6,
    "Data de início": "03/11/2020",
    "Data de fim": "08/12/2020",
    "Período Recesso": "não se aplica",
    "Meios de comunicação utilizados?": "Teams, moodle Tads, e-mail e whatsapp",
    "Planos de Ensino": "ds662.pdf",
    "Meses": "nov,dez"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS662",
    "Período": 6,
    "Nome da disciplina": "Ferramentas de Qualidade",
    "Docente responsável": "Paulo Eduardo Sobreira Moraes",
    "Contato do.pdfente": "paulomoraes@ufpr.br",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 5,
    "CH Sem": 5,
    "Semanas": 6,
    "Data de início": "03/11/2020",
    "Data de fim": "08/12/2020",
    "Período Recesso": "não se aplica",
    "Meios de comunicação utilizados?": "Teams, moodle Tads, e-mail e whatsapp",
    "Planos de Ensino": "ds662.pdf",
    "Meses": "nov,dez"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS660",
    "Período": 6,
    "Nome da disciplina": "Empreendedorismo e inovação",
    "Docente responsável": "Paulo Eduardo Sobreira Moraes",
    "Contato do.pdfente": "paulomoraes@ufpr.br",
    "Número de vagas (veteranos/calouros)": 10,
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 5,
    "CH Sem": 5,
    "Semanas": 6,
    "Data de início": "03/11/2020",
    "Data de fim": "08/12/2020",
    "Período Recesso": "não se aplica",
    "Meios de comunicação utilizados?": "Teams, moodle Tads, e-mail e whatsapp",
    "Planos de Ensino": "ds660.pdf",
    "Meses": "nov,dez"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS660",
    "Período": 6,
    "Nome da disciplina": "Empreendedorismo e inovação",
    "Docente responsável": "Paulo Eduardo Sobreira Moraes",
    "Contato do.pdfente": "paulomoraes@ufpr.br",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 5,
    "CH Sem": 5,
    "Semanas": 6,
    "Data de início": "03/11/2020",
    "Data de fim": "08/12/2020",
    "Período Recesso": "não se aplica",
    "Meios de comunicação utilizados?": "Teams, moodle Tads, e-mail e whatsapp",
    "Planos de Ensino": "ds660.pdf",
    "Meses": "nov,dez"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS260",
    "Período": 6,
    "Nome da disciplina": "Governança de TI",
    "Docente responsável": "Luiz Antônio Pereira Neves",
    "Contato do.pdfente": "neves@ufpr.br",
    "Número de vagas (veteranos/calouros)": 10,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "segunda",
    "Horário (ativ. síncronas)": "19:00-20:00",
    "CH Sem Síncrona": 1,
    "CH Sem Assíncrona": 4,
    "CH Sem": 5,
    "Semanas": 12,
    "Data de início": "03/11/2020",
    "Data de fim": "08/03/2020",
    "Período Recesso": "21/12/20 a 19/01/21",
    "Meios de comunicação utilizados?": "Teams, moodle Tads, e-mail e whatsapp",
    "Planos de Ensino": "ds260.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS260",
    "Período": 6,
    "Nome da disciplina": "Governança de TI",
    "Docente responsável": "Luiz Antônio Pereira Neves",
    "Contato do.pdfente": "neves@ufpr.br",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 60,
    "Dias da semana (ativ. síncronas)": "segunda",
    "Horário (ativ. síncronas)": "19:00-20:00",
    "CH Sem Síncrona": 1,
    "CH Sem Assíncrona": 4,
    "CH Sem": 5,
    "Semanas": 12,
    "Data de início": "03/11/2020",
    "Data de fim": "08/03/2020",
    "Período Recesso": "21/12/20 a 19/01/21",
    "Meios de comunicação utilizados?": "Teams, moodle Tads, e-mail e whatsapp",
    "Planos de Ensino": "ds260.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS960",
    "Período": 6,
    "Nome da disciplina": "TCC 2",
    "Docente responsável": "Docentes núcleo duro",
    "Contato do.pdfente": "-",
    "Número de vagas (veteranos/calouros)": 60,
    "Carga Horária da disciplina": 150,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 10,
    "CH Sem": 10,
    "Semanas": 10,
    "Data de início": "03/11/2020",
    "Data de fim": "01/04/2021",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "E-mail, Teams e Moodle TADS",
    "Planos de Ensino": "ds960.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS960",
    "Período": 6,
    "Nome da disciplina": "TCC 2",
    "Docente responsável": "Docentes núcleo duro",
    "Contato do.pdfente": "-",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 150,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 10,
    "CH Sem": 10,
    "Semanas": 15,
    "Data de início": "03/11/2020",
    "Data de fim": "01/04/2021",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "E-mail, Teams e Moodle TADS",
    "Planos de Ensino": "ds960.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "TI164",
    "Período": 6,
    "Nome da disciplina": "Estágio Obrigatório",
    "Docente responsável": "Docentes núcleo duro",
    "Contato do.pdfente": "-",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 240,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 16,
    "CH Sem": 16,
    "Semanas": 15,
    "Data de início": "03/11/2020",
    "Data de fim": "01/04/2021",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "E-mail, Teams e Moodle TADS",
    "Planos de Ensino": "ti164.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "TI164",
    "Período": 6,
    "Nome da disciplina": "Estágio Obrigatório",
    "Docente responsável": "Docentes núcleo duro",
    "Contato do.pdfente": "-",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 240,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 16,
    "CH Sem": 16,
    "Semanas": 15,
    "Data de início": "03/11/2020",
    "Data de fim": "01/04/2021",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "E-mail, Teams e Moodle TADS",
    "Planos de Ensino": "ti164.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "TI163",
    "Período": 6,
    "Nome da disciplina": "Laboratório de Desenvolvimento de Sistemas",
    "Docente responsável": "Docentes núcleo duro",
    "Contato do.pdfente": "-",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 195,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 13,
    "CH Sem": 13,
    "Semanas": 15,
    "Data de início": "03/11/2020",
    "Data de fim": "01/04/2021",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "E-mail, Teams e Moodle TADS",
    "Planos de Ensino": "ti163.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "TI163",
    "Período": 6,
    "Nome da disciplina": "Laboratório de Desenvolvimento de Sistemas",
    "Docente responsável": "Docentes núcleo duro",
    "Contato do.pdfente": "-",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 195,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 13,
    "CH Sem": 13,
    "Semanas": 15,
    "Data de início": "03/11/2020",
    "Data de fim": "01/04/2021",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "E-mail, Teams e Moodle TADS",
    "Planos de Ensino": "ti163.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "TI166",
    "Período": 6,
    "Nome da disciplina": "Trabalho de Conclusão de Curso",
    "Docente responsável": "Docentes núcleo duro",
    "Contato do.pdfente": "-",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 15,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 1,
    "CH Sem": 1,
    "Semanas": 15,
    "Data de início": "03/11/2020",
    "Data de fim": "01/04/2021",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "E-mail, Teams e Moodle TADS",
    "Planos de Ensino": "ti166.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "TI166",
    "Período": 6,
    "Nome da disciplina": "Trabalho de Conclusão de Curso",
    "Docente responsável": "Docentes núcleo duro",
    "Contato do.pdfente": "-",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 15,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 1,
    "CH Sem": 1,
    "Semanas": 15,
    "Data de início": "03/11/2020",
    "Data de fim": "01/04/2021",
    "Período Recesso": "21/12/20 a 16/01/21",
    "Meios de comunicação utilizados?": "E-mail, Teams e Moodle TADS",
    "Planos de Ensino": "ti166.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "NI147",
    "Período": "Op",
    "Nome da disciplina": "Relacionamento Interpessoal",
    "Docente responsável": "Paulo Eduardo Sobreira Moraes",
    "Contato do.pdfente": "paulomoraes@ufpr.br",
    "Número de vagas (veteranos/calouros)": 10,
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 5,
    "CH Sem": 5,
    "Semanas": 6,
    "Data de início": "03/11/2020",
    "Data de fim": "08/12/2020",
    "Período Recesso": "não se aplica",
    "Meios de comunicação utilizados?": "Teams, moodle Tads, e-mail e whatsapp",
    "Planos de Ensino": "ni147.pdf",
    "Meses": "nov,dez"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "NI147",
    "Período": "Op",
    "Nome da disciplina": "Relacionamento Interpessoal",
    "Docente responsável": "Paulo Eduardo Sobreira Moraes",
    "Contato do.pdfente": "paulomoraes@ufpr.br",
    "Número de vagas (veteranos/calouros)": 30,
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 5,
    "CH Sem": 5,
    "Semanas": 6,
    "Data de início": "03/11/2020",
    "Data de fim": "08/12/2020",
    "Período Recesso": "não se aplica",
    "Meios de comunicação utilizados?": "Teams, moodle Tads, e-mail e whatsapp",
    "Planos de Ensino": "ni147.pdf",
    "Meses": "nov,dez"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS878",
    "Período": "Op",
    "Nome da disciplina": "Processamento Digital de Imagens",
    "Docente responsável": "Luiz Antônio Pereira Neves",
    "Contato do.pdfente": "neves@ufpr.br",
    "Número de vagas (veteranos/calouros)": 10,
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "segunda",
    "Horário (ativ. síncronas)": "21:00-22:00",
    "CH Sem Síncrona": 1,
    "CH Sem Assíncrona": 1.5,
    "CH Sem": 2.5,
    "Semanas": 12,
    "Data de início": "03/11/2020",
    "Data de fim": "08/03/2020",
    "Período Recesso": "21/12/2020 a 19/01/2021",
    "Meios de comunicação utilizados?": "Teams, moodle Tads, e-mail e whatsapp",
    "Planos de Ensino": "ds878.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS878",
    "Período": "Op",
    "Nome da disciplina": "Processamento Digital de Imagens",
    "Docente responsável": "Luiz Antônio Pereira Neves",
    "Contato do.pdfente": "neves@ufpr.br",
    "Número de vagas (veteranos/calouros)": 20,
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "segunda",
    "Horário (ativ. síncronas)": "21:00-22:00",
    "CH Sem Síncrona": 1,
    "CH Sem Assíncrona": 1.5,
    "CH Sem": 2.5,
    "Semanas": 12,
    "Data de início": "03/11/2020",
    "Data de fim": "08/03/2020",
    "Período Recesso": "21/12/2020 a 19/01/2021",
    "Meios de comunicação utilizados?": "Teams, moodle Tads, e-mail e whatsapp",
    "Planos de Ensino": "ds878.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS803",
    "Período": "Op",
    "Nome da disciplina": "Inteligência Artificial Aplicada I",
    "Docente responsável": "Roberto Tadeu Raittz",
    "Contato do.pdfente": "raittz@ufpr.br",
    "Número de vagas (veteranos/calouros)": 10,
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "quarta",
    "Horário (ativ. síncronas)": "16:30-17:30",
    "CH Sem Síncrona": 1,
    "CH Sem Assíncrona": 4,
    "CH Sem": 5,
    "Semanas": 6,
    "Data de início": "03/11/2020",
    "Data de fim": "27/03/2021",
    "Período Recesso": "16/11/2020 a 16/01/2021; 01/02/2021 a 06/03/2021",
    "Meios de comunicação utilizados?": "Teams, moodle Tads, e-mail e google drive",
    "Planos de Ensino": "ds803.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS803",
    "Período": "Op",
    "Nome da disciplina": "Inteligência Artificial Aplicada I",
    "Docente responsável": "Roberto Tadeu Raittz",
    "Contato do.pdfente": "raittz@ufpr.br",
    "Número de vagas (veteranos/calouros)": 20,
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "quarta",
    "Horário (ativ. síncronas)": "16:30-17:30",
    "CH Sem Síncrona": 1,
    "CH Sem Assíncrona": 4,
    "CH Sem": 5,
    "Semanas": 6,
    "Data de início": "03/11/2020",
    "Data de fim": "27/03/2021",
    "Período Recesso": "16/11/2020 a 16/01/2021; 01/02/2021 a 06/03/2021",
    "Meios de comunicação utilizados?": "Teams, moodle Tads, e-mail e google drive",
    "Planos de Ensino": "ds803.pdf",
    "Meses": "nov,dez,jan,fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "47A",
    "Código da disciplina": "DS875",
    "Período": "Op",
    "Nome da disciplina": "Inglês Técnico",
    "Docente responsável": "Juliana Passos",
    "Contato do.pdfente": "julianapassos@ufpr.br",
    "Número de vagas (veteranos/calouros)": 20,
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 5,
    "CH Sem": 5,
    "Semanas": 6,
    "Data de início": "01/02/2021",
    "Data de fim": "26/03/2021",
    "Período Recesso": "até 31/01",
    "Meios de comunicação utilizados?": "UFPR Virtual, e-mail",
    "Planos de Ensino": "ds875.pdf",
    "Meses": "fev,mar"
  },
  {
    "Curso 47A tarde 48A noite": "48A",
    "Código da disciplina": "DS875",
    "Período": "Op",
    "Nome da disciplina": "Inglês Técnico",
    "Docente responsável": "Juliana Passos",
    "Contato do.pdfente": "julianapassos@ufpr.br",
    "Número de vagas (veteranos/calouros)": 40,
    "Carga Horária da disciplina": 30,
    "Dias da semana (ativ. síncronas)": "-",
    "Horário (ativ. síncronas)": "-",
    "CH Sem Síncrona": 0,
    "CH Sem Assíncrona": 5,
    "CH Sem": 5,
    "Semanas": 6,
    "Data de início": "01/02/2021",
    "Data de fim": "26/03/2021",
    "Período Recesso": "até 31/01",
    "Meios de comunicação utilizados?": "UFPR Virtual, e-mail",
    "Planos de Ensino": "ds875.pdf",
    "Meses": "fev,mar"
  }
]
*/
export default disciplinas;
